import React from "react";
import ServiceOverview from "../components/ServiceSection/ServiceOverview";
import MainService from "../components/ServiceSection/MainService";
import Process from "../components/ServiceSection/Process";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import WhatsAppChat from "../components/WhatsAppChat";


const Service = () => {
    return (
        <div>
            <Navbar />
            <ServiceOverview/>
            <MainService/>
            <Process/>
            <FAQ/>
            <Footer/>
            <WhatsAppChat/>
        </div>
    );
};

export default Service;